export const HOME_NO_DATA = 'homepage.no-data'
export const HOME_NO_USER_PREFERENCES_CONTINUE = 'homepage.no-user-preferences-continue'
export const HOME_NO_USER_PREFERENCES_STORE = 'homepage.no-user-preferences-store'
